import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { Spinner } from '../../../../components/Spinner';
import { useAuth } from '../../../../contexts/AuthContext';
import { useMutateSlackID } from '../hooks/useMutateSlackID';

export type SlackAuthResponse = {
  authed_user: {
    id: string;
  };
  ok: boolean;
};
function SlackCallback(): JSX.Element {
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');
  const { userData } = useAuth();
  const navigate = useNavigate();
  const { mutate: mutateSlackID } = useMutateSlackID();
  useEffect(() => {
    if (code) {
      const fetchSlackUser = async (): Promise<void> => {
        try {
          const tokenResponse = await fetch(
            'https://slack.com/api/oauth.v2.access',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
              body: new URLSearchParams({
                client_id: process.env.REACT_APP_SLACK_CLIENT_ID || '',
                client_secret: process.env.REACT_APP_SLACK_CLIENT_SECRET || '',
                code,
                redirect_uri: `${window.location.origin}/auth/slack/callback`,
              }),
            },
          );
          const { authed_user: authedUser } =
            (await tokenResponse.json()) as SlackAuthResponse;
          if (userData?.id && authedUser?.id) {
            mutateSlackID({
              userId: userData.id,
              slackID: authedUser.id,
            });
          }
        } catch (error) {
          console.error('Slack OAuth Error:', error);
        } finally {
          navigate('/settings/integrations');
        }
      };

      fetchSlackUser().catch((error) => {
        console.error('Slack OAuth Error:', error);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code, userData?.id]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <Spinner />
    </div>
  );
}

export default SlackCallback;
